import { InsertLink, Print } from "@mui/icons-material";
import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import useClipboard from "react-use-clipboard";
import { Translations } from "../../localization/translations";
import useKlasisSnackbar from "../../utils/klasisSnackbar";

interface ITitleBarProps {
    title: string;
    showCommands?: boolean;
    rightSideElement?: JSX.Element | JSX.Element[];
}

const TitleBar: React.FC<ITitleBarProps> = (props: ITitleBarProps) => {
    const { t } = useTranslation();
    const { klasisEnqueueSnackbar } = useKlasisSnackbar();

    const [isCopied, setCopied] = useClipboard(window.location.href);

    const handleCopyToClipboard = (): void => {
        setCopied();

        klasisEnqueueSnackbar(t(Translations.common.label.linkCopySuccess));
    };

    const renderCommands = (): JSX.Element | null => {
        if (!props.showCommands) return null;

        return (
            <Box display="flex" alignItems="center">
                <Tooltip title={t(Translations.common.tooltip.copyPageLink)}>
                    <IconButton onClick={handleCopyToClipboard}>
                        <InsertLink />
                    </IconButton>
                </Tooltip>
                <Tooltip title={t(Translations.common.tooltip.printPage)}>
                    <IconButton onClick={() => window.print()}>
                        <Print />
                    </IconButton>
                </Tooltip>
            </Box>
        );
    };

    return (
        <>
            <Grid container>
                <Grid
                    item
                    sm={12}
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                    }}
                >
                    <Typography
                        color="primary"
                        variant="h5"
                        style={{ padding: "1rem 0 1rem 0" }}
                    >
                        {props.title}
                    </Typography>

                    {renderCommands()}
                </Grid>
            </Grid>
        </>
    );
};

export default TitleBar;
